import styled from 'styled-components';
import { useSettings } from '@wu/widget-core';
import { useIconSectionColor, useItemsInRow } from '../../../../helpers';
import { Icon } from '../../../common';
import { ItemLayout } from '../items-layouts';
import { useData } from '../main-layouts';
import { SectionsTitle, SectionsTitleComponent } from './SectionsTitle';

export function SectionsLayoutList() {
  const [itemsCount, containerRef] = useItemsInRow();
  const { visibleSections, itemsBySections } = useData();

  const {
    sectionTitleFontStyle: { fontSize: sectionTitleFontSize }
  } = useSettings();

  const iconSize = sectionTitleFontSize * 1.333;
  const iconColor = useIconSectionColor();

  const renderItems = (id: string) => {
    const sectionItems = itemsBySections[id];
    return (
      <Items>
        {sectionItems?.map((menuItem, menuId) => {
          return (
            <ItemLayout
              data={menuItem}
              key={menuId}
              width={100 / Number(itemsCount || 1)}
              showImage={sectionItems.some((item) => item.image)}
            />
          );
        })}
      </Items>
    );
  };

  return (
    <Container ref={containerRef}>
      {visibleSections?.map(({ id, name, icon }) => (
        <Component key={id}>
          {visibleSections.length > 1 && (
            <StyledSectionsTitle>
              {icon && (
                <Icon
                  icon={icon}
                  size={iconSize}
                  fill={iconColor}
                  style={{ marginRight: '12px' }}
                  alt=""
                />
              )}
              {name}
            </StyledSectionsTitle>
          )}
          {renderItems(id)}
        </Component>
      ))}
    </Container>
  );
}

const Container = styled.div``;
const Component = styled.div`
  &:not(&:last-child) {
    margin-bottom: 26px;
  }

  ${SectionsTitleComponent} {
    margin-bottom: 16px;
  }
`;

const Items = styled.div`
  min-width: calc(100% + 48px);
  display: flex;
  flex-wrap: wrap;
  margin: 0 -24px;
  justify-content: center;
`;

const StyledSectionsTitle = styled(SectionsTitle)`
  justify-content: center;
`;
